import { render, staticRenderFns } from "./ivrRepeat.vue?vue&type=template&id=095a04d5"
import script from "./ivrRepeat.vue?vue&type=script&lang=js"
export * from "./ivrRepeat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports